<template>
  <div id="search-form-opening-type">
    <div class="search-form-opening-type__field">
      <b-form-group label="Opening type" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          id="btn-radios-opening-type"
          v-model="openingTypeOptionModel"
          :options="openingTypeOptions"
          :aria-describedby="ariaDescribedby"
          name="radios-btn-opening-type"
          buttons
        />
      </b-form-group>
      <div v-if="isByArrangement && groupSizeSection" class="search-form-opening-type__group-size">
        <p class="group-size-label">How many people are in your group?</p>
        <div class="group-size-options">
          <b-button
            v-for="(option, index) in groupSizeSection.options"
            :key="index"
            :pressed="isGroupSizeSelected(option.value)"
            size="sm"
            class="group-size-option-button"
            @click="selectGroupSize(option)"
          >
            {{ option.label }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SearchFormOpeningType',

  props: {
    openingTypeOption: {
      type: String,
      required: true,
    },
    openingTypeOptions: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters('filter', [
      'dynamicFilterSectionByKey',
      'filterSelected',
    ]),

    openingTypeOptionModel: {
      get() {
        return this.openingTypeOption
      },
      set(value) {
        this.$emit('update:opening-type-option', value)
      },
    },

    isByArrangement() {
      return this.openingTypeOption === 'by-arrangement-visit'
    },

    groupSizeSection() {
      return this.dynamicFilterSectionByKey('group_size')
    },
  },

  methods: {
    ...mapActions('filter', ['addFilter']),

    isGroupSizeSelected(value) {
      return this.groupSizeSection && this.filterSelected(this.groupSizeSection.filter, value)
    },

    selectGroupSize(option) {
      this.addFilter({
        filter: this.groupSizeSection.filter,
        type: this.groupSizeSection.display_type,
        options: option.value,
        silent: true,
      })
    },
  },
}
</script>

<style scoped lang="scss">

#search-form-opening-type {
  padding: 16px;

  .search-form-opening-type__field {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  ::v-deep .form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 0;
  }

  ::v-deep .form-group label,
  ::v-deep .form-group legend {
    font-family: "Gill Sans", "Inter", sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: $color-text-dark;
    margin-bottom: 0;
  }

  ::v-deep .btn-group {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;

    @include media-breakpoint-up(lg) {
      flex-direction: row;
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1 1 0;
      min-height: 40px;
      padding: 8px 12px;
      border-radius: 4px;
      border: 1px solid $color-grey-dark-20;
      background-color: #fff;
      font-family: "Gill Sans", "Inter", sans-serif;
      font-size: 18px;
      line-height: 1;
      color: $color-text-dark;

      &:hover:not(.active) {
        border-color: $color-grey-dark-20;
        background-color: $color-yellow-bright;
      }

      &.active {
        background-color: $color-yellow-bright;
        border-color: $color-grey-dark;
        font-weight: 600;
      }
    }
  }

  .search-form-opening-type__group-size {
    margin-top: 4px;
    background-color: #fff;
    border: 1px solid $color-grey-dark-20;
    border-radius: 4px;
    padding: 16px;

    .group-size-label {
      font-family: "Gill Sans", "Inter", sans-serif;
      font-size: 16px;
      color: $color-text-dark;
      margin-bottom: 12px;
    }

    .group-size-options {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      .group-size-option-button {
        font-family: "Gill Sans", "Inter", sans-serif;
        font-size: 16px;
        border-radius: 4px;
        border: 1px solid $color-grey-dark-20;
        color: $color-text-dark;

        &:hover:not(.active) {
          background-color: $color-yellow-bright;
        }

        &.active {
          background-color: $color-yellow-bright;
          border-color: $color-grey-dark;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
